module.exports = __webpack_public_path__ + "img/Frame-21.b663eaf2.svg";